import React from 'react'
import styled, { css } from 'styled-components'

export default ({ z = '1', debug = false, xsTop, xsBottom, mdTop, mdBottom, lgTop, lgBottom, ...props }) => {
  return (
    <Container
      z={z}
      debug={debug}
      xsTop={xsTop}
      xsBottom={xsBottom}
      mdTop={mdTop}
      mdBottom={mdBottom}
      lgTop={lgTop}
      lgBottom={lgBottom}
      {...props}>
      <svg viewBox="0 0 858 26" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
        <title>wave</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M596.097 0.699219L633.418 20.7302L670.682 0.730237L707.945 20.7302L745.209 0.730238L782.473 20.7302L819.736 0.730237L857.946 21.2379L856.054 24.7623L819.736 5.26996L782.473 25.27L745.209 5.26996L707.945 25.27L670.682 5.26995L633.418 25.27L596.21 5.29973C596.07 5.38369 595.916 5.47594 595.748 5.576C594.831 6.12436 593.517 6.90737 591.928 7.84685C588.75 9.72532 584.466 12.2315 580.052 14.7391C575.642 17.244 571.082 19.7618 567.354 21.6577C565.494 22.6041 563.812 23.4101 562.448 23.9842C561.767 24.2707 561.136 24.5118 560.584 24.6844C560.079 24.8422 559.467 25.0001 558.891 25.0001C558.292 25.0001 557.695 24.8319 557.212 24.6626C556.693 24.4802 556.123 24.2287 555.527 23.9366C554.334 23.3518 552.899 22.5358 551.324 21.5893C549.06 20.2284 546.408 18.5373 543.64 16.7717C542.561 16.084 541.465 15.385 540.367 14.6898C536.421 12.1904 532.43 9.72607 528.99 7.88943C527.269 6.97092 525.725 6.23047 524.419 5.72419C523.068 5.20008 522.152 5.0001 521.627 5.0001C521.126 5.0001 520.312 5.18737 519.128 5.69661C517.979 6.19112 516.639 6.91918 515.135 7.83394C512.54 9.41165 509.616 11.4454 506.535 13.5884C506.032 13.9377 505.526 14.2899 505.016 14.6435C501.418 17.1394 497.663 19.6939 494.188 21.6236C490.794 23.5078 487.323 25.0001 484.364 25.0001C481.36 25.0001 478.162 23.4718 475.113 21.5728C472.347 19.8504 469.406 17.6242 466.485 15.4133C466.124 15.1404 465.764 14.8677 465.405 14.5963C462.085 12.0903 458.798 9.66632 455.623 7.86441C452.422 6.04752 449.567 5.0001 447.1 5.0001C438.896 5.0001 434.772 9.35312 430.058 14.3697L430.029 14.4007C425.335 19.3955 420.068 25.0001 409.844 25.0001C399.662 25.0001 394.479 19.435 389.846 14.4602L389.756 14.3632C385.099 9.36283 380.968 5.0001 372.589 5.0001C364.209 5.0001 360.079 9.36284 355.42 14.3634L355.331 14.4587C350.697 19.4342 345.512 25.0001 335.325 25.0001C325.143 25.0001 319.96 19.435 315.327 14.4602L315.237 14.3632C310.579 9.36283 306.449 5.0001 298.069 5.0001C289.69 5.0001 285.559 9.36284 280.901 14.3634L280.812 14.4586C276.177 19.4341 270.993 25.0001 260.806 25.0001C250.624 25.0001 245.441 19.435 240.808 14.4602L240.717 14.3632C236.06 9.36283 231.93 5.0001 223.55 5.0001C215.175 5.0001 211.046 9.36238 206.389 14.3632L206.301 14.4569C201.667 19.433 196.482 25.0001 186.294 25.0001C176.106 25.0001 170.922 19.433 166.287 14.457L166.2 14.3632C161.542 9.36238 157.414 5.0001 149.039 5.0001C140.659 5.0001 136.529 9.36284 131.87 14.3634L131.781 14.4587C127.147 19.4342 121.962 25.0001 111.775 25.0001C101.593 25.0001 96.41 19.435 91.777 14.4602L91.6866 14.3632C87.0293 9.36283 82.899 5.0001 74.5193 5.0001C66.1396 5.0001 62.0093 9.36284 57.3509 14.3634L57.2621 14.4587C52.6274 19.4342 47.4427 25.0001 37.2557 25.0001C27.0735 25.0001 21.8907 19.435 17.2576 14.4602L17.1673 14.3632C12.51 9.36283 8.37969 5.0001 0 5.0001V1.0001C10.1881 1.0001 15.3728 6.56717 20.007 11.5432L20.0944 11.637C24.7521 16.6378 28.8803 21.0001 37.2557 21.0001C45.6354 21.0001 49.7657 16.6374 54.4241 11.6368L54.5129 11.5415C59.1476 6.56601 64.3323 1.0001 74.5193 1.0001C84.7074 1.0001 89.8921 6.56716 94.5264 11.5432L94.6137 11.637C99.2714 16.6378 103.4 21.0001 111.775 21.0001C120.155 21.0001 124.285 16.6374 128.943 11.6368L129.032 11.5415C133.667 6.56602 138.852 1.0001 149.039 1.0001C159.221 1.0001 164.404 6.56518 169.037 11.54L169.127 11.637C173.784 16.6374 177.915 21.0001 186.294 21.0001C194.674 21.0001 198.804 16.6374 203.462 11.637L203.552 11.54C208.185 6.5652 213.368 1.0001 223.55 1.0001C233.738 1.0001 238.923 6.56718 243.557 11.5432L243.644 11.637C248.302 16.6378 252.43 21.0001 260.806 21.0001C269.185 21.0001 273.316 16.6374 277.974 11.6368L278.063 11.5416C282.698 6.56605 287.882 1.0001 298.069 1.0001C308.257 1.0001 313.442 6.56714 318.076 11.5432L318.164 11.637C322.821 16.6378 326.95 21.0001 335.325 21.0001C343.705 21.0001 347.835 16.6374 352.493 11.6368L352.582 11.5415C357.217 6.56598 362.402 1.0001 372.589 1.0001C382.777 1.0001 387.962 6.56721 392.596 11.5433L392.683 11.637C397.341 16.6378 401.469 21.0001 409.844 21.0001C418.231 21.0001 422.447 16.6279 427.143 11.6305L427.304 11.459C431.945 6.51848 437.13 1.0001 447.1 1.0001C450.605 1.0001 454.192 2.45267 457.598 4.38578C461.03 6.33387 464.511 8.90989 467.815 11.4039C468.177 11.6771 468.536 11.9491 468.893 12.2193C471.842 14.4508 474.628 16.5584 477.227 18.1774C480.199 20.0284 482.567 21.0001 484.364 21.0001C486.206 21.0001 488.886 19.9924 492.246 18.1265C495.524 16.3063 499.126 13.8608 502.737 11.3567C503.236 11.0101 503.737 10.6621 504.236 10.3146C507.306 8.17889 510.348 6.0634 513.056 4.41626C514.635 3.45601 516.154 2.62157 517.547 2.02233C518.906 1.43782 520.315 1.0001 521.627 1.0001C522.916 1.0001 524.396 1.42511 525.865 1.99475C527.38 2.58222 529.082 3.40427 530.873 4.36076C534.458 6.27413 538.559 8.8098 542.508 11.3104C543.637 12.0255 544.752 12.7366 545.841 13.4309C548.589 15.1836 551.169 16.8294 553.385 18.1609C554.93 19.0894 556.249 19.8359 557.287 20.3448C557.807 20.5996 558.222 20.7778 558.537 20.8884C558.739 20.9593 558.854 20.9856 558.899 20.9951C558.952 20.9852 559.106 20.9556 559.39 20.8666C559.775 20.7462 560.278 20.5576 560.897 20.2972C562.132 19.7776 563.715 19.0211 565.541 18.0925C569.186 16.2384 573.684 13.7562 578.076 11.2611C582.464 8.76866 586.726 6.27488 589.893 4.40335C591.475 3.46782 592.784 2.68833 593.696 2.14295C594.152 1.87026 594.509 1.65613 594.751 1.51031L595.098 1.30162L595.116 1.291L595.12 1.28838L595.121 1.28775C595.121 1.28763 595.122 1.28758 596.155 3.0001L595.121 1.28775L596.097 0.699219Z"
          fill="url(#paint0_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="857"
            y1="13.0023"
            x2="-10.3157"
            y2="13.0019"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#7D28EA" />
            <stop offset="1" stopColor="#D25050" />
          </linearGradient>
        </defs>
      </svg>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  z-index: ${({ z }) => (z ? z : 1)}!important;
  svg {
    width: 100%;
  }
  ${({ debug }) =>
    debug &&
    css`
      border: ${`2px dashed ${debug}`};
    `}

  ${({ xsBottom }) =>
    xsBottom &&
    css`
      padding-bottom: ${xsBottom};
    `}

  ${({ xsTop }) =>
    xsTop &&
    css`
      padding-bottom: ${xsTop};
    `}

  ${({ mdBottom }) =>
    mdBottom &&
    css`
      @media (min-width: 720px) {
        padding-bottom: ${mdBottom};
      }
    `}

    ${({ mdTop }) =>
      mdTop &&
      css`
        @media (min-width: 720px) {
          padding-top: ${mdTop};
        }
      `}

  ${({ lgBottom }) =>
    lgBottom &&
    css`
      @media (min-width: 1025px) {
        padding-bottom: ${lgBottom};
      }
    `}

    ${({ lgTop }) =>
      lgTop &&
      css`
        @media (min-width: 1025px) {
          padding-top: ${lgTop};
        }
      `}
`
